module.exports = __webpack_public_path__ + "static/media/newInstance.d2edc063.svg";